import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import PublicInvoice from './pages/PublicInvoice';
// Dunning demo (self-serve, /d). Remove with the two /d routes below.
import DunningPayPage from './dunning_demo/DunningPayPage';
import TryDemoPage from './dunning_demo/TryDemoPage';

// Simple auth guard component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('jwtToken');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          {/* Public invoice route - no authentication required */}
          <Route path="/invoice/:hash" element={<PublicInvoice />} />
          <Route path="/d" element={<TryDemoPage />} />
          <Route path="/d/:token" element={<DunningPayPage />} />
          {/* Redirect any unknown routes to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
